export default __webpack_public_path__ + "968784d3e084d08259186c1d93dfec03.woff";